import { HouseKeepingStatus } from "../enums/HKStatuses";

export class vwRoomHkStatus {
  Szonum:string;
  DateValue:string;
  HkStatus : HouseKeepingStatus
}
